module.exports = __webpack_public_path__ + "img/tarot-major-arcana-18.d64528e8.png";